import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import axios from 'axios';
import { vxm } from '@/store.vuex';
import { SocialProfile } from './socialprofile';
import { SocialProfileGroup } from './socialprofilegroup';
@Module({ namespacedPath: 'socialprofiles/' })
export class SocialProfileStore extends VuexModule {
  private socialNetworksOptions: string[] = [];
  private socialProfileGroupList: SocialProfileGroup[] = [];

  public get SocialNetworksOptions() {
    this.socialNetworksOptions.sort();
    return this.socialNetworksOptions;
  }

  @mutation
  public setSocialNetworksOptions(payload) {
    this.socialNetworksOptions = payload;
  }

  public get SocialProfileGroupList() {
    return this.socialProfileGroupList;
  }

  @mutation
  public setSocialProfileGroupList(payload = []) {
    this.socialProfileGroupList = payload;
  }

  @action({ mode: 'mutate' })
  public async getSocialProfileData() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v1/social-network',
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    if (resp.data.meta.success) {
      this.setSocialNetworksOptions(resp.data.data.socialNetworksMeta);
      this.setSocialProfileGroupList(resp.data.data.socialNetworkDetails);
    }
  }

  @action({ mode: 'mutate' })
  public async addSocialProfileData(socialprofile: SocialProfile) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;

    const formData = new FormData();
    if (socialprofile.id != 0)
      formData.append('id', socialprofile.id.toString());
    formData.append('profileURL', socialprofile.profileLink);
    formData.append('name', socialprofile.name);
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/social-network/create',
      {
        name: socialprofile.name,
        profileLink: socialprofile.profileLink,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async saveUpdateSocialProfileDataList(
    socialProfileList: SocialProfile[],
  ) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/social-network',
      {
        socialNetworkProfiles: socialProfileList,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deleteSocialProfiles(profileIds: number[]) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/social-network/ids/socialNetworks',
      profileIds,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }
}
